import Vue from "vue";
import Vuex from "vuex";
import SecureLS from "secure-ls";
import Auth from "@/modules/Auth.js";
import Web from "@/modules/Web.js";
import Event from "@/modules/Event.js";
import Preference from "@/modules/Preference.js";
import createPersistedState from "vuex-persistedstate";
import Lead from "@/modules/Lead.js";
import ShoppingCartStore from "@/modules/ShoppingCartStore.js";

Vue.use(Vuex);

const secureLs = new SecureLS({
  isCompression: false,
});

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => secureLs.get(key),
        setItem: (key, value) => secureLs.set(key, value),
        removeItem: (key) => secureLs.remove(key),
      },
    }),
  ],
  mutations: {
    /*
        setBeforeRoute(state,beforeRoute){
          state.beforeRoute = beforeRoute
        },
        setDraw(state) {
          state.draw = !state.draw;
        },
        setOver(state, over) {
          state.over = over;
        },
        setMessages(state, message){
          if(message === 'clear'){
            state.messages = [];
          }else{
            state.messages.push(message);
          }
        }
        */
  },
  actions: {
    /*
        setBefore({commit},beforeRoute ) {
          commit('setBeforeRoute', beforeRoute)
        },
        setDraw({commit}) {
          commit('setDraw')
        },
        setOver({commit}, over) {
          commit('setOver', over);
        },
        setMessages({commit}, message){
          commit('setMessages', message);
        },
        */
  },
  getters: {
    /*
        getBeforeRoute(state){
          return state.beforeRoute;
        },
        getDraw(state) {
          return state.draw
        },
        getOver(state) {
          return state.over;
        },
        getMessages(state){
          return state.messages;
        }
        */
  },
  modules: {
    Auth,
    Event,
    Web,
    Preference,
    Lead,
    ShoppingCartStore,
  },
});
